export type DeckSlide = { title: string; bullets: string[] }

function textOf(el: Element | null): string {
  return (el?.textContent ?? "").trim()
}

function extractSlide(container: Element): DeckSlide {
  const heading = container.querySelector("h1, h2, h3")
  const title = textOf(heading)
  const listItems = Array.from(container.querySelectorAll("li"))
  let bullets: string[]
  if (listItems.length > 0) {
    bullets = listItems.map((li) => textOf(li)).filter(Boolean)
  } else {
    bullets = Array.from(container.querySelectorAll("p"))
      .map((p) => textOf(p))
      .filter(Boolean)
  }
  return { title, bullets }
}

export function parseDeck(html: string): DeckSlide[] {
  if (!html.trim()) return []
  const doc = new DOMParser().parseFromString(html, "text/html")
  // Ta bort script/style så deras text aldrig läcker in i punkter
  doc.querySelectorAll("script, style").forEach((el) => el.remove())
  const sections = Array.from(doc.querySelectorAll("section"))
  if (sections.length > 0) {
    return sections.map((section) => extractSlide(section))
  }
  // Ingen <section> → behandla hela body som en slide
  if (!textOf(doc.body)) return []
  return [extractSlide(doc.body)]
}
